namespace RecordShield.Workspace {
    export interface SubscriberRow {
        UserId?: number;
        Username?: string;
        DisplayName?: string;
        Email?: string;
        Source?: string;
        PasswordHash?: string;
        PasswordSalt?: string;
        LastDirectoryUpdate?: string;
        UserImage?: string;
        IsActive?: number;
        IsdCode?: string;
        Mobile?: string;
        ParentId?: number;
        PackageId?: number;
        TenantId?: number;
        DeviceType?: string;
        DeviceId?: string;
        ParentUsername?: string;
        ParentDisplayName?: string;
        ParentEmail?: string;
        ParentSource?: string;
        ParentPasswordHash?: string;
        ParentPasswordSalt?: string;
        ParentLastDirectoryUpdate?: string;
        ParentUserImage?: string;
        ParentInsertDate?: string;
        ParentInsertUserId?: number;
        ParentUpdateDate?: string;
        ParentUpdateUserId?: number;
        ParentIsActive?: number;
        ParentIsdCode?: string;
        ParentMobile?: string;
        ParentParentId?: number;
        ParentPackageId?: number;
        ParentCustomerKey?: number;
        PackageName?: string;
        PackageDescription?: string;
        PackageHrs?: number;
        PackageFileSize?: number;
        PackageDuration?: number;
        PackageActivations?: number;
        PackageCorporateActivations?: number;
        PackageEncryptRatePerHour?: number;
        PackageEncryptRatePerMb?: number;
        PackageActivationRate?: number;
        PackageCorporateActivationRate?: number;
        PackageMoqEncryptHours?: number;
        PackageMoqEncryptSize?: number;
        PackageMoqActivations?: number;
        PackageMoqCorporateActivations?: number;
        PackageBasePrice?: number;
        PackageInstallationCost?: number;
        PackageFinalPrice?: number;
        InsertUserId?: number;
        InsertDate?: string;
        UpdateUserId?: number;
        UpdateDate?: string;
    }

    export namespace SubscriberRow {
        export const idProperty = 'UserId';
        export const isActiveProperty = 'IsActive';
        export const nameProperty = 'Username';
        export const localTextPrefix = 'Workspace.Subscriber';
        export const lookupKey = 'Workspace.Subscriber';

        export function getLookup(): Q.Lookup<SubscriberRow> {
            return Q.getLookup<SubscriberRow>('Workspace.Subscriber');
        }

        export namespace Fields {
            export declare const UserId: string;
            export declare const Username: string;
            export declare const DisplayName: string;
            export declare const Email: string;
            export declare const Source: string;
            export declare const PasswordHash: string;
            export declare const PasswordSalt: string;
            export declare const LastDirectoryUpdate: string;
            export declare const UserImage: string;
            export declare const IsActive: string;
            export declare const IsdCode: string;
            export declare const Mobile: string;
            export declare const ParentId: string;
            export declare const PackageId: string;
            export declare const TenantId: string;
            export declare const DeviceType: string;
            export declare const DeviceId: string;
            export declare const ParentUsername: string;
            export declare const ParentDisplayName: string;
            export declare const ParentEmail: string;
            export declare const ParentSource: string;
            export declare const ParentPasswordHash: string;
            export declare const ParentPasswordSalt: string;
            export declare const ParentLastDirectoryUpdate: string;
            export declare const ParentUserImage: string;
            export declare const ParentInsertDate: string;
            export declare const ParentInsertUserId: string;
            export declare const ParentUpdateDate: string;
            export declare const ParentUpdateUserId: string;
            export declare const ParentIsActive: string;
            export declare const ParentIsdCode: string;
            export declare const ParentMobile: string;
            export declare const ParentParentId: string;
            export declare const ParentPackageId: string;
            export declare const ParentCustomerKey: string;
            export declare const PackageName: string;
            export declare const PackageDescription: string;
            export declare const PackageHrs: string;
            export declare const PackageFileSize: string;
            export declare const PackageDuration: string;
            export declare const PackageActivations: string;
            export declare const PackageCorporateActivations: string;
            export declare const PackageEncryptRatePerHour: string;
            export declare const PackageEncryptRatePerMb: string;
            export declare const PackageActivationRate: string;
            export declare const PackageCorporateActivationRate: string;
            export declare const PackageMoqEncryptHours: string;
            export declare const PackageMoqEncryptSize: string;
            export declare const PackageMoqActivations: string;
            export declare const PackageMoqCorporateActivations: string;
            export declare const PackageBasePrice: string;
            export declare const PackageInstallationCost: string;
            export declare const PackageFinalPrice: string;
            export declare const InsertUserId: string;
            export declare const InsertDate: string;
            export declare const UpdateUserId: string;
            export declare const UpdateDate: string;
        }

        ['UserId', 'Username', 'DisplayName', 'Email', 'Source', 'PasswordHash', 'PasswordSalt', 'LastDirectoryUpdate', 'UserImage', 'IsActive', 'IsdCode', 'Mobile', 'ParentId', 'PackageId', 'TenantId', 'DeviceType', 'DeviceId', 'ParentUsername', 'ParentDisplayName', 'ParentEmail', 'ParentSource', 'ParentPasswordHash', 'ParentPasswordSalt', 'ParentLastDirectoryUpdate', 'ParentUserImage', 'ParentInsertDate', 'ParentInsertUserId', 'ParentUpdateDate', 'ParentUpdateUserId', 'ParentIsActive', 'ParentIsdCode', 'ParentMobile', 'ParentParentId', 'ParentPackageId', 'ParentCustomerKey', 'PackageName', 'PackageDescription', 'PackageHrs', 'PackageFileSize', 'PackageDuration', 'PackageActivations', 'PackageCorporateActivations', 'PackageEncryptRatePerHour', 'PackageEncryptRatePerMb', 'PackageActivationRate', 'PackageCorporateActivationRate', 'PackageMoqEncryptHours', 'PackageMoqEncryptSize', 'PackageMoqActivations', 'PackageMoqCorporateActivations', 'PackageBasePrice', 'PackageInstallationCost', 'PackageFinalPrice', 'InsertUserId', 'InsertDate', 'UpdateUserId', 'UpdateDate'].forEach(x => (<any>Fields)[x] = x);
    }
}
